import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'

const SELECTOR = 'a[href*="#"]:not([href="#todo"])'
export default class Page extends Component {
    constructor(element) {
        super(element)

        this.state = {
            menuItem: null,
            activeState: null,
            navigation: null,
            cookies: null,
        }

        this.headerMain = null
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)

        // https://gist.github.com/shimondoodkin/1081133/cfb74dde66261a892c5db1726ff97f7edcd3f780
        if(/AppleWebKit\/([\d.]+)/.exec(navigator.userAgent)) { // detect webkit
            var refocus_prevtarget = null;
            function refocusContentEditable() {
                var curelement=window.event.target;
                if(refocus_prevtarget) { // if we have a previous element
                    // if previous element was contentEditable and the next isn't then:
                    if(refocus_prevtarget.contentEditable == 'true' && curelement.contentEditable !== 'true') {
                        document.getElementsByClassName('CKEditable').setSelectionRange(0, 0); // set caret focus to an element that handles caret focus correctly.
                        curelement.focus(); // focus the wanted element.
                    }
                }
                refocus_prevtarget=curelement;
            }
            document.addEventListener("click", refocusContentEditable, false); // add global click handler
        }

        // Cookies checker
        window.onload = function() {
            const headerMain = document.querySelector('.header-Main')
            const alert = document.querySelector('.Alert')

            if(window.innerWidth < 767) {
                if(!document.cookie.includes('gCookieConsent')) {
                    if (headerMain) {
                        headerMain.style.opacity = 1
                    }
                    setTimeout(() => {
                        document.querySelectorAll('.gc-Button--outline').forEach((button) => {
                            button.addEventListener('click', () => {
                                if(localStorage.getItem('alert')) {
                                    headerMain?.classList.add('is-bottom-pinned')
                                } else {
                                    alert?.classList.add('is-active')
                                }
                            })
                        })
                    }, 1000)
                } else if (alert) {
                    setTimeout(() => {
                        if (headerMain) {
                            headerMain.style.opacity = 1
                        }
                    }, 1500)

                    if(localStorage.getItem('alert')) {
                        headerMain?.classList.add('is-bottom-pinned')
                    }
                } else {
                    headerMain?.classList.add('is-bottom-pinned')
                    setTimeout(() => {
                        if (headerMain) {
                            headerMain.style.opacity = 1
                        }
                    }, 1500)
                }
            } else {
                if(!document.cookie.includes('gCookieConsent')) {
                    setTimeout(() => {
                        document.querySelectorAll('.gc-Button--outline').forEach((button) => {
                            button.addEventListener('click', () => {
                                alert?.classList.add('is-active')
                            })
                        })
                    }, 2000)
                }
            }
        };
    }

    handleClick = (event) => {
        if (event.defaultPrevented) {
            return
        }

        const id =
            event.target.dataset.scrollTo || event.target.closest(SELECTOR)?.href?.split('#')[1]

        if (!id) {
            return
        }

        const element = document.getElementById(id)

        if (!element) {
            return
        }
        event.preventDefault()

        if (element.matches('.Section:not(.Section--appended):not(.Section--bare)')) {
            scrollToElement(element, {
                offset: 0,
            })
        } else {
            scrollToElement(element, {
                offset: 150,
            })
        }
    }
}
